module.exports = __webpack_public_path__ + "static/media/drag-and-drop-rectangle .9f6c7d4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drag-and-drop-rectangle .svg
// module id = 91
// module chunks = 0